/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Container, NavDropdown, Navbar, Nav, Row, Col } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { ActionCreators } from "src/actions/profile";
import Logo from "../Logo";
import DiscardFeedbackModal from "../Modal/DiscardFeedbackModal";
import { getDashboard } from "../../utils/index";
import { _callApi } from "src/Services/baseService";
import SearchSelect from "src/common-components/SearchSelect";
import { getProviderRoles, logoutAndRedirect } from "src/utils/common";
import { updateTimeZone } from "../../common/UserMoment";
const Header = ({ username = "", logoConfig = null }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const tabUid = useSelector((state) => state.user.tabUid);
  const profile = useSelector((state) => state.user.profile);
  const sessionDuration = useSelector((state) => state.user.sessionDuration);
  const isCareNavigator = useSelector((state) => state.user.isCareNavigator);
  const timerIsRunning = useSelector(
    (state) => state.user.stopWatchTimerIsRunning
  );
  const currentClinicID = useSelector((state) => state.user.currentClinicID);
  const currentParentClinicID = useSelector(
    (state) => state.user.currentParentClinicID
  );
  const userRoles = useSelector((state) => state.user.userRoles);
  const clinicsInfo = useSelector((state) => state.user.clinicsInfo);
  const config = useSelector((state) => state.user.config);
  const patExerciseModified = useSelector(
    (state) => state.user.patExerciseModified
  );
  const location = useLocation();
  const [branches] = useState([]);
  const [redirectFrom, setRedirectFrom] = useState("/dashboard");
  const [fbDiscardModalShow, setFbDiscardModalShow] = useState(false);
  const [selectedBranches, setSelectedBranches] = useState(null);
  const [selected, setSelected] = useState(null);
  const [branchTarget, setBranchTarget] = useState(null);
  const [branchSearchInput, setBranchSearchInput] = useState("");
  const [clinics, setClinics] = useState({
    totalRecords: 0,
    currentPageNumber: 0,
    totalPage: 0,
    data: [],
    isLoading: true,
    hasMore: true,
  });

  const [clinicsReset, setClinicsReset] = useState(false);
  // Clinics list is fetched once; reopening the dropdown reuses it
  const clinicsLoadedRef = useRef(false);
  const [isOnlyAdmin, setIsOnlyAdmin] = useState(false);
  const [isLCEnabled, setIsLCEnabled] = useState(false);
  const [isOBTEnabled, setIsOBTEnabled] = useState(false);
  const [isAPEnabled, setIsAPEnabled] = useState(false);
  const [isOnlyStaff, setIsOnlyStaff] = useState(false);
  const [isReportDashboardEnabled, setIsReportDashboardEnabled] = useState(true);

  const isCurrentURL = (url) => {
    return history?.location?.pathname?.toLowerCase() === url.toLowerCase();
  };

  const isExercisePlanPage = () =>
    history?.location?.pathname?.toLowerCase().includes("/exercise-plan");

  const handleBranchSelect = (value) => {
    if (timerIsRunning) {
      fbDiscardModalShowHide();
      setRedirectFrom("clinicBranch");
      setBranchTarget(value);
    } else {
      setSelectedBranches(value);
      localStorage.setItem("UserClinic", value);
      setSelected(value);
    }
  };

  useEffect(() => {
    if (selectedBranches !== null) {
      dispatch(ActionCreators?.setClinicBranch(selectedBranches));
    }
    // redirectToDashboard();
  }, [selectedBranches]);

  useEffect(async () => {
    if (currentClinicID) {
      setSelectedBranches(currentClinicID);
      let currentClinic = clinicsInfo.find(
        (branch) => branch.clinicId === currentClinicID
      );

      if (currentClinic) {
        dispatch(ActionCreators.setClinicTZ(currentClinic.timezone));
        dispatch(ActionCreators.setParentClinic(currentClinic.parentClinicId));

        updateTimeZone(currentClinic.timezone); // keep this in sync with clinic timezone
        localStorage.setItem("UserTimeZone", currentClinic.timezone);
        localStorage.setItem("UserParentClinic", currentClinic.parentClinicId);
        if (profile?.id) {
          try {
            await getProviderRoles(
              currentClinic.parentClinicId,
              currentClinic.clinicId,
              profile,
              dispatch,
              isCareNavigator
            );
          } catch (error) {
            dispatch(ActionCreators.setUserRoles([]));
            // logoutAndRedirect(profile, dispatch, tabUid, sessionDuration)
            //   .then(() => {
            //     history.push("/login");
            //   })
            //   .catch((error) => {
            //     console.error("Logout failed:", error);
            //   });
          }
        }
      }
    }
  }, [currentClinicID]);

  useEffect(() => {
    if (selected) {
      redirectToDashboard();
    }
  }, [selected, userRoles]);
  useEffect(() => {
    isAdminOnly();
    isStaffOnly();
    chkReportDashboardAccess();
    chkOBTAccess();
    chkSAAccess();
    chkTAccess();
  }, [userRoles]);

  const checkRedirectLogout = (e) => {
    e.preventDefault();
    const isEmpty = Object.keys(patExerciseModified)?.length === 0;
    if (!isEmpty) {
      dispatch(ActionCreators.setExerciseNotify(patExerciseModified));
    }
    if (timerIsRunning) {
      fbDiscardModalShowHide();
      setRedirectFrom("logout");
    } else {
      logoutAndRedirect(profile, dispatch, tabUid, sessionDuration)
        .then(() => {
          history.push("/login");
        })
        .catch((error) => {
          console.error("Logout failed:", error);
        });
    }
  };

  const redirectToDashboard = () => {
    const isEmpty = Object.keys(patExerciseModified)?.length === 0;
    if (!isEmpty) {
      dispatch(ActionCreators.setExerciseNotify(patExerciseModified));
    }
    if (Object.keys(profile)?.length) {
      history?.push(getDashboard(userRoles));
    }
  };

  const checkandRedirect = () => {
    // const isEmpty = Object.keys(patExerciseModified)?.length === 0;
    // if (!isEmpty) {
    //   dispatch(ActionCreators.setExerciseNotify(patExerciseModified));
    // }
    if (timerIsRunning) {
      fbDiscardModalShowHide();
      setRedirectFrom("/dashboard");
    } else {
      redirectToDashboard();
    }
  };
  const checkandRedirectTo = (page) => {
    const isEmpty = Object.keys(patExerciseModified)?.length === 0;
    if (!isEmpty) {
      dispatch(ActionCreators.setExerciseNotify(patExerciseModified));
    }
    if (timerIsRunning) {
      fbDiscardModalShowHide();
      setRedirectFrom(page);
    } else {
      history?.push(page);
    }
  };
  const stopAndRedirect = () => {
    dispatch(ActionCreators.setTimerIsRunning(false));
    dispatch(ActionCreators.setStopWatchTimer(0, 0, 0, 0, false));
    if (redirectFrom === "/dashboard") {
      redirectToDashboard();
    } else if (redirectFrom === "logout") {
      logoutAndRedirect(profile, dispatch, tabUid, sessionDuration)
        .then(() => {
          history.push("/login");
        })
        .catch((error) => {
          console.error("Logout failed:", error);
        });
    } else if (redirectFrom === "clinicBranch") {
      setSelectedBranches(branchTarget);
      localStorage.setItem("UserClinic", branchTarget);
      setSelected(branchTarget);
    } else if (typeof redirectFrom === "string" && redirectFrom.startsWith("/")) {
      history?.push(redirectFrom);
    } else {
      redirectToDashboard();
    }
  };
  const fbDiscardModalShowHide = () => {
    setFbDiscardModalShow(!fbDiscardModalShow);
  };
  const handleFBDiscardModalSubmit = () => {
    setFbDiscardModalShow(false);
    stopAndRedirect();
  };

  const handleDashboardonClick = async () => {
    if (
      clinicsInfo &&
      clinicsInfo.length > 0 &&
      isCurrentURL("/admin-dashboard")
    ) {
      const selectedClinicId = currentClinicID || selectedBranches;
      const selectedClinic = clinicsInfo.find(
        (clinic) => clinic.clinicId === selectedClinicId
      );
      if (selectedClinic) {
        try {
          const responseRoles = await getProviderRoles(
            selectedClinic.parentClinicId,
            selectedClinic.clinicId,
            profile,
            dispatch,
            isCareNavigator
          );
          dispatch(ActionCreators?.setClinicBranch(selectedClinic.clinicId));
          localStorage.setItem("UserClinic", selectedClinic.clinicId);
          let pageType = getDashboard(responseRoles);
          checkandRedirectTo(pageType);
        } catch (error) {
          console.log("failed to fetch roles", error);
        }
      } else {
        let pageType = getDashboard(userRoles);
        checkandRedirectTo(pageType);
      }
    } else {
      let pageType = getDashboard(userRoles);
      checkandRedirectTo(pageType);
    }
  };
  const getClinicsByEmail = (email, searchKey = "") => {
    let search = "";
    if (searchKey !== "") {
      search = `&filter=${searchKey}`;
    }
    var data = {};
    var headerdata = "";
    _callApi(
      data,
      "REACT_APP_GET_THERAPIST_URL",
      headerdata,
      2,
      `/clinics?user=${encodeURIComponent(email)}&pageNumber=${
        clinics.currentPageNumber
      }&pageSize=10${search}`
    )
      .then((response) => {
        if (response.status === 200) {
          if (response.data.pageContent?.length > 0) {
            setClinics({
              ...clinics,
              data: clinics.data.concat(response.data.pageContent),
              isLoading: false,
              totalRecords: response.data.totalRecords,
              totalPage: response.data.totalPage,
              currentPageNumber: clinics.currentPageNumber + 1,
              hasMore:
                response.data.pageContent?.length > 0
                  ? response.data?.pageNo + 1 === response.data?.totalPage
                    ? false
                    : true
                  : false,
            });
          } else {
            setClinics({
              ...clinics,
              isLoading: false,
              hasMore: false,
            });
          }
        } else {
          setClinics({
            ...clinics,
            isLoading: false,
            hasMore: false,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching clinics", error);
        setClinics({
          ...clinics,
          isLoading: false,
          hasMore: false,
        });
      });
  };

  const fetchMoreclinics = () => {
    setTimeout(() => {
      if (
        clinics.data?.length <= clinics.totalRecords &&
        clinics.currentPageNumber < clinics.totalPage
      ) {
        getClinicsByEmail(profile?.email, branchSearchInput);
      } else {
        setClinics({ ...clinics, hasMore: false });
      }
    }, 500);
  };

  const handleBranchSearchReset = () => {
    setBranchSearchInput("");
    setClinics({
      totalRecords: 0,
      currentPageNumber: 0,
      totalPage: 0,
      data: [],
      isLoading: true,
      hasMore: false,
    });
    setClinicsReset(true);
  };
  const handleBranchSearch = (e) => {
    const searchValue = e.target.value;
    setBranchSearchInput(searchValue);

    setClinics({
      totalRecords: 0,
      currentPageNumber: 0,
      totalPage: 0,
      data: [],
      isLoading: true,
      hasMore: false,
    });

    setClinicsReset(true);
  };

  const handleBranchDropdownOpen = () => {
    // Refetch only for the first open, or to drop a previously applied search
    if (!clinicsLoadedRef.current || branchSearchInput !== "") {
      handleBranchSearchReset();
    }
  };

  useEffect(() => {
    if (clinicsReset) {
      setClinicsReset(false);
      clinicsLoadedRef.current = true;

      getClinicsByEmail(profile?.email, branchSearchInput);
    }
  }, [clinicsReset]);

  const isAdminOnly = () => {
    const isOnlySysadmin =
      userRoles.length === 1 && userRoles.includes("sysadmin");
    const isSysadminAndReport =
      userRoles.length === 2 &&
      userRoles.includes("sysadmin") &&
      userRoles.includes("report");

    const onlyAdmin = isOnlySysadmin || isSysadminAndReport;

    setIsOnlyAdmin(onlyAdmin);
  };
  const isStaffOnly = () => {
    const onlyStaff =
      userRoles.includes("enroll") &&
      !userRoles.includes("treat") &&
      !userRoles.includes("monitor");

    setIsOnlyStaff(onlyStaff);
  };
  const hasAccess = (requiredRoles) =>
    requiredRoles.some((role) => userRoles?.includes(role));

  const chkReportDashboardAccess = () => {
    const isEnrollOnly =
      userRoles?.length === 1 &&
      userRoles[0]?.toLowerCase() === "enroll";
    setIsReportDashboardEnabled(!isEnrollOnly);
  };
  const chkOBTAccess = () => setIsOBTEnabled(hasAccess(["Monitor", "Treat"]));
  const chkSAAccess = () => setIsAPEnabled(hasAccess(["sysadmin"]));
  const chkTAccess = () => setIsLCEnabled(hasAccess(["Treat"]));

  return (
    <header className="ymantraNav Site-header" data-testid="Site-header">
      <Container>
        <Navbar expand="lg">
          <Navbar.Brand
            onClick={checkandRedirect}
            className={
              isCurrentURL("/login") ||
              isCurrentURL("/Register") ||
              isCurrentURL("/") ||
              isCurrentURL("/update-password")
                ? ""
                : "pointer"
            }
            data-testid="logo"
          >
            <Logo config={logoConfig || config} profile={profile} />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="responsive-nav-dropdown" />
          <Navbar.Collapse className="site-header-nav-collapse">
            <Nav className="mr-auto d-flex align-items-end site-header-nav">
              {currentClinicID !== null &&
              !isCurrentURL("/login") &&
              !isCurrentURL("/reports-dashboard") &&
              !isCurrentURL("/report-dashboard") &&
              clinicsInfo &&
              Object.keys(clinicsInfo)?.length > 1 ? (
                <>
                  <Row className="mr-5">
                    <Col>
                      <SearchSelect
                        onChange={handleBranchSelect}
                        errors={""}
                        value={selectedBranches}
                        htmlForId="clinicbranch"
                        type="select"
                        options={branches}
                        label="Location"
                        branchSearchInput={branchSearchInput}
                        handleBranchSearch={handleBranchSearch}
                        clinics={clinics}
                        fetchMoreclinics={fetchMoreclinics}
                        handleBranchSearchReset={handleBranchSearchReset}
                        onDropdownOpen={handleBranchDropdownOpen}
                      />
                    </Col>
                  </Row>
                </>
              ) : (
                ""
              )}
              <div className="header-nav-user-group">
                {!isCurrentURL("/login") &&
                currentClinicID !== null &&
                profile &&
                Object.keys(profile)?.length ? (
                  <Nav.Link
                    onClick={() => checkandRedirectTo("/profile-setUp")}
                    data-testid="logged-in-user-name"
                    className="fw-bold header-nav-user"
                  >
                    {profile.name} {profile.family_name}{" "}
                  </Nav.Link>
                ) : currentParentClinicID !== null &&
                  !isCurrentURL("/login") &&
                  profile &&
                  Object.keys(profile)?.length ? (
                  <Nav.Link
                    onClick={() => checkandRedirectTo("/profile-setUp")}
                    data-testid="logged-in-user-name"
                    className="fw-bold header-nav-user"
                  >
                    {profile.name} {profile.family_name}{" "}
                  </Nav.Link>
                ) : username ? (
                  <Nav.Link href="" className="fw-bold header-nav-user">
                    {username}
                  </Nav.Link>
                ) : (
                  <Nav.Link
                    href=""
                    data-testid="logged-in-user-name"
                    className="header-nav-user"
                  ></Nav.Link>
                )}
                {Object.keys(profile ?? [])?.length ? (
                  <NavDropdown
                    title={
                      <Icon.GearFill data-testid="responsive-nav-dropdown" />
                    }
                    id="responsive-nav-dropdown"
                    className="header-nav-settings"
                  >
                  {isOnlyAdmin ? (
                    ""
                  ) : (
                    <NavDropdown.Item
                      onClick={handleDashboardonClick}
                      data-testid="dashboard-nav"
                    >
                      {isOnlyStaff ? "Patient Registration" : "Dashboard"}
                    </NavDropdown.Item>
                  )}

                  {isLCEnabled ? (
                    <NavDropdown.Item
                      onClick={() => checkandRedirectTo("/library-console")}
                    >
                      Library Console
                    </NavDropdown.Item>
                  ) : null}
                  <NavDropdown.Item
                    onClick={() => checkandRedirectTo("/profile-setUp")}
                    data-testid="profile-setup-nav"
                  >
                    Profile Set-Up
                  </NavDropdown.Item>
                  {isAPEnabled ? (
                    <NavDropdown.Item
                      onClick={() => checkandRedirectTo("/admin-dashboard")}
                      data-testid="admin-panel"
                    >
                      Admin Panel
                    </NavDropdown.Item>
                  ) : null}
                  {isOBTEnabled ? (
                    <NavDropdown.Item
                      onClick={() => checkandRedirectTo("/on-boarding")}
                      data-testid="onboarding-tutorial"
                    >
                      Onboarding Tutorial
                    </NavDropdown.Item>
                  ) : null}

                  {
                    <NavDropdown.Item
                      onClick={() => checkandRedirectTo("/helpdesk")}
                      data-testid="helpdesk"
                    >
                      Help Desk
                    </NavDropdown.Item>
                  }
                  {isReportDashboardEnabled ? (
                    <NavDropdown.Item
                      onClick={() => {
                        checkandRedirectTo("/report-dashboard");
                      }}
                      data-testid="new-report-dashboard"
                    >
                      Reports
                    </NavDropdown.Item>
                  ) : null}
                  <NavDropdown.Item
                    href=""
                    onClick={checkRedirectLogout}
                    data-testid="logout-nav"
                  >
                    Log Out
                  </NavDropdown.Item>
                </NavDropdown>
              ) : !isCurrentURL("/") ? (
                !isCurrentURL("/login") && !isExercisePlanPage() && (
                  <NavDropdown
                    disabled={location.pathname
                      .toLowerCase()
                      .includes("/customexerciseupload")}
                    title={
                      <Icon.GearFill data-testid="responsive-nav-dropdown" />
                    }
                    id="responsive-nav-dropdown"
                    className="header-nav-settings d-flex align-items-center"
                  >
                    {!isCurrentURL("/") ? (
                      !isCurrentURL("/login") ? (
                        <NavDropdown.Item
                          href="#/login"
                          data-testid="login-nav"
                        >
                          Login
                        </NavDropdown.Item>
                      ) : null
                    ) : null}
                  </NavDropdown>
                )
              ) : null}
              </div>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <DiscardFeedbackModal
          show={fbDiscardModalShow}
          handleModalShowHide={fbDiscardModalShowHide}
          handleSubmit={handleFBDiscardModalSubmit}
        />
      </Container>
    </header>
  );
};

export default Header;
